import type { UsersTranslations } from './types'

/**
 * Arabic translations for Users domain
 */
export const arTranslations: UsersTranslations = {
  // Page/Section level
  title: "المستخدمين",
  subtitle: "إدارة المستخدمين والصلاحيات",

  // Actions
  addUser: "إضافة مستخدم",
  editUser: "تعديل المستخدم",
  deleteUser: "حذف المستخدم",

  // Search and filters
  searchPlaceholder: "البحث في المستخدمين...",
  noItemsFound: "لم يتم العثور على مستخدمين",
  noItemsDescription: "لم تقم بإضافة أي مستخدمين بعد.",
  addFirst: "أضف أول مستخدم",

  // Form section
  form: {
    name: "اسم المستخدم",
    namePlaceholder: "أدخل اسم المستخدم",
    status: "الحالة",
    validation: {
      nameRequired: "اسم المستخدم مطلوب",
    }
  },

  // Status
  status: {
    active: "نشط",
    inactive: "غير نشط",
  },

  // Messages
  messages: {
    createSuccess: "تم إنشاء المستخدم بنجاح",
    updateSuccess: "تم تحديث المستخدم بنجاح",
    deleteSuccess: "تم حذف المستخدم بنجاح",
    deleteConfirm: "هل أنت متأكد من حذف هذا المستخدم؟",
  },

  // Table headers
  table: {
    name: "الاسم",
    status: "الحالة",
  },

  // Top-level convenience keys
  name: "الاسم",
  namePlaceholder: "أدخل اسم المستخدم",
  statusLabel: "الحالة",
  nameRequired: "اسم المستخدم مطلوب",
  active: "نشط",
  inactive: "غير نشط",
  createSuccess: "تم إنشاء المستخدم بنجاح",
  updateSuccess: "تم تحديث المستخدم بنجاح",
  deleteSuccess: "تم حذف المستخدم بنجاح",
  deleteConfirm: "هل أنت متأكد من حذف هذا المستخدم؟",

  // Attempt lockout
  unlockAttempts: "إلغاء قفل الحساب (المحاولات)",
  attemptBlocked: "مقفل (محاولات كثيرة)",

  // Customer Onboarding
  onboarding: {
    title: 'إعداد العملاء',
    subtitle: 'تسجيل عملاء SAP الحاليين كمستخدمين في البوابة',
    modeManual: 'إدخال يدوي',
    modeExcel: 'استيراد Excel',
    successMessage: 'تم تسجيل العميل بنجاح',
    errorMessage: 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
    submit: 'تسجيل العميل',
    submitting: 'جارٍ التسجيل...',
    steps: {
      account: 'الحساب',
      business: 'الأعمال',
      address: 'العنوان',
    },
    form: {
      nameAndCompany: 'الشركة / الاسم الكامل',
      nameAndCompanyPlaceholder: 'أدخل اسم الشركة أو الاسم الكامل',
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'أدخل البريد الإلكتروني',
      mobilePhone: 'رقم الجوال',
      password: 'كلمة المرور',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      regeneratePassword: 'توليد جديد',
      autoGeneratedBadge: 'مولّدة تلقائياً',
      sapBusinessPartnerNumber: 'رقم شريك SAP',
      sapCustomerGroup: 'مجموعة عميل SAP',
      vatNumber: 'رقم ضريبة القيمة المضافة',
      crNumber: 'رقم السجل التجاري',
      addressLine1: 'عنوان الشارع',
      addressLine1Placeholder: 'أدخل عنوان الشارع',
      city: 'المدينة',
      region: 'المنطقة',
      regionPlaceholder: 'اختر المنطقة',
      postalCode: 'الرمز البريدي',
      country: 'الدولة',
    },
    excel: {
      dropzone: 'أفلت ملف Excel هنا',
      dropzoneHint: 'يقبل ملفات .xlsx, .xls من صادرات SAP',
      browseFile: 'تصفح الملف',
      parseError: 'فشل في قراءة الملف. تأكد من أنه ملف Excel صالح.',
      customersLoaded: 'عميل تم تحميله',
      emailsGenerated: 'بريد إلكتروني مولّد',
      succeeded: 'نجح',
      failed: 'فشل',
      clear: 'مسح',
      registerAll: 'تسجيل الكل',
      retryFailed: 'إعادة محاولة الفاشلين',
      bulkSuccess: 'تم تسجيل {{count}} عميل بنجاح',
      downloadResults: 'تحميل النتائج',
      col: {
        sap: 'رقم SAP',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        city: 'المدينة',
        status: 'الحالة',
        password: 'كلمة المرور',
      },
      status: {
        pending: 'انتظار',
        submitting: 'جارٍ التسجيل...',
        success: 'نجاح',
        error: 'فشل',
      },
    },
  },
}
